import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button';
import ZoomSlider from '@Containers/Zoom/ZoomSlider';
import GridListViewButton from '@Containers/ResultToolbar/GridListViewButton';

function ResultToolbarSecondary(props) {
  const {
    context,
    zoomOnMouseEnterHandler,
    zoomOnMouseLeaveHandler,
    isReactionsContext,
    showConditions,
    toggleConditions,
    isHeatmapAvailable,
    isHeatmapDisabled,
    onHeatmapButtonClick,
  } = props;
  return (
    <div className="u-els-margin-top-1o2 o-els-flex-layout o-els-flex-layout--right o-els-flex-layout--middle o-els-flex-layout--wrap@mobile">
      {isReactionsContext && (
        <ButtonWithIcon
          id="toggleConditions"
          onClick={() => {
            toggleConditions();
          }}
          title="Toggle Conditions"
          type="link"
          linkIconSize="xs"
          sprite={showConditions ? 'EyeNotVisible' : 'EyeVisible'}
          layout="vertical"
          className="result-toolbar-toggle-conditions-button e2e-conditions"
          data-e2e="toggle-conditions-button">
          {showConditions ? 'Hide' : 'Show'} Conditions
        </ButtonWithIcon>
      )}
      <ZoomSlider
        {...props}
        onMouseEnterHandler={zoomOnMouseEnterHandler}
        onMouseLeaveHandler={zoomOnMouseLeaveHandler}
        className="u-els-margin-left"
        zoomKey={context}
      />
      <GridListViewButton {...props} />
      {isHeatmapAvailable && (
        <ButtonWithIcon
          id="heatmap"
          type="link"
          linkIconSize="xs"
          disabled={isHeatmapDisabled}
          aria-disabled={isHeatmapDisabled}
          aria-label="Bioactivity Visualization"
          className="result-toolbar-heatmap-button u-els-margin-left e2e-heatmap"
          sprite="MatrixView"
          iconRight
          onClick={() => {
            onHeatmapButtonClick();
          }}
          data-e2e="bioactivity-visualization-button">
          Bioactivity Visualization
        </ButtonWithIcon>
      )}
    </div>
  );
}

export default ResultToolbarSecondary;
